import React, { useEffect, useContext, useState, useRef } from "react";
import { InputContainer } from "uikit-react";
import { Form, FormRow, FormInputWrapper } from "../../ui";
import classnames from "classnames";

import UIkit from "uikit";
import { AppContexts } from "../../providers";

const ChatbotFaqsAdd = ({ data, onSuccess }) => {
  const offCanvasRef = useRef(null);
  const { loading, createFaq, updateFaq } = useContext(
    AppContexts.ChatbotContext,
  );

  const [faq, setFaq] = useState(null);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (!data) {
      setFaq(null);
      UIkit.offcanvas(offCanvasRef.current).hide();
    } else {
      setFaq({ ...data });
      UIkit.offcanvas(offCanvasRef.current).show();
    }
  }, [data]);

  const update = (key, e) => {
    setFaq({ ...faq, [key]: e.target.value });
  };

  const validate = () => {
    const required = ["question", "answer"];
    const errs = [];

    required.map((key) => {
      if (faq[key].trim() === "") {
        errs.push(key);
      }
    });

    setErrors(errs);
    return errs;
  };

  const submit = async (e) => {
    e.preventDefault();

    let errs = validate();
    let msg = "";
    let status = "success";

    if (errs.length > 0) {
      return;
    }

    try {
      if (faq.id) {
        await updateFaq(faq.id, {
          question: faq.question.trim(),
          answer: faq.answer.trim(),
        });

        msg = "FAQ updated successfully";
        status = "success";
      } else {
        await createFaq({
          question: faq.question.trim(),
          answer: faq.answer.trim(),
          template_id: faq.template_id || null,
        });

        msg = "FAQ created successfully";
        status = "success";
      }

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      msg = "Failed to save FAQ";
      status = "danger";
    }

    UIkit.notification({
      message: msg,
      status: status,
    });
  };

  return (
    <div
      id="add-ai-faq"
      ref={offCanvasRef}
      className="uk-modal-full hms-modals uk-modal uk-open"
      uk-offcanvas="flip: true; overlay: true"
    >
      <div className="uk-offcanvas-bar">
        <div className="hms-modals-main">
          <button
            className="uk-offcanvas-close uk-close-large"
            type="button"
            uk-close="true"
          />
          <div className="uk-modal-header">
            <h2 className="uk-modal-title">
              {faq?.id ? "Update FAQ" : "Add FAQ"}
            </h2>
          </div>
          <div className="uk-modal-body uk-flex">
            <Form className="uk-grid-small" uk-grid="true" onSubmit={submit}>
              <FormRow>
                <FormInputWrapper label="Question*" size="two">
                  <InputContainer>
                    <input
                      className={classnames("uk-input", {
                        error: errors.includes("question"),
                      })}
                      type="text"
                      placeholder="Enter the question"
                      value={faq?.question || ""}
                      onInput={(e) => {
                        update("question", e);
                      }}
                    />
                  </InputContainer>
                </FormInputWrapper>
              </FormRow>
              <FormRow>
                <FormInputWrapper label="Answer*" size="two">
                  <InputContainer>
                    <textarea
                      className={classnames("uk-textarea", {
                        error: errors.includes("answer"),
                      })}
                      rows="5"
                      placeholder="Enter the answer"
                      value={faq?.answer || ""}
                      onInput={(e) => {
                        update("answer", e);
                      }}
                    />
                  </InputContainer>
                </FormInputWrapper>
              </FormRow>
              <div>
                <button
                  className="uk-button hms-btn hms-red-btn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <div uk-spinner="ratio: 0.6"></div>
                      {faq?.id ? "Updating..." : "Adding..."}
                    </>
                  ) : faq?.id ? (
                    "Update"
                  ) : (
                    "Add"
                  )}
                </button>
                <button
                  className="uk-button hms-btn uk-offcanvas-close"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatbotFaqsAdd;
